/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Reason_DisabledInputs */

const en_sorx_reason_disabled = /** @type {(inputs: Sorx_Reason_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the channel is switched off`)
};

const id_sorx_reason_disabled = /** @type {(inputs: Sorx_Reason_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kanal sedang dimatikan`)
};

/**
* | output |
* | --- |
* | "the channel is switched off" |
*
* @param {Sorx_Reason_DisabledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_reason_disabled = /** @type {((inputs?: Sorx_Reason_DisabledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Reason_DisabledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_reason_disabled(inputs)
	return en_sorx_reason_disabled(inputs)
});